import React, { useEffect, useState } from "react";
import { INVOICE_TRACKING_HOSTNAME } from "../../../../common-utilities/utils/end-points";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { Box, Card, Grid, IconButton, Link, Typography } from "@mui/material";
import "./index.scss";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { convertToCamelCaseFromUnderScore } from "../../../../common-utilities/utils";
import { REST_URLS } from "../../../../common-utilities/utils/end-points/invoice-tracking";
import { Stack } from "rsuite";
import ApprovalTimeLine from "./approval-timeline";

const DocumentDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [documentDetails, setPODetails] = useState({});
  const { uploadDocs = {} } = documentDetails;

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LEGAL_DOCUMENT}/${id}`,
      null,
      null
    )
      .then((response) => {
        if (response.message) {
        } else if (response.id) {
          setPODetails(response || {});
        }
      })
      .catch((err) => {});
  };

  return (
    <Box sx={{ margin: 2 }}>
      <Card sx={{ mb: 2 }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{ mb: 2 }}
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <IconButton
              onClick={() => {
                navigate(-1);
              }}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h5">
              Document Details for {documentDetails?.id}
            </Typography>
          </Stack>
          <Typography sx={{ marginRight: 1 }}>
            Current Stage :{" "}
            {convertToCamelCaseFromUnderScore(documentDetails?.stage || "")}
          </Typography>
        </Stack>
      </Card>
      <Card>
        <Grid container spacing={2} sx={{ margin: 2 }}>
          <Grid xs={7} className="info-section">
            <Grid container spacing={2} marginBottom={2}>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: 14 }}>Document Type</Typography>
                <Typography variant="span">
                  {documentDetails?.documentType || ""}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: 14 }}>Vendor Type </Typography>
                <Typography> {documentDetails?.typeOfVendor || ""}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: 14 }}>Vendor Name </Typography>
                <Typography variant="span">
                  {documentDetails?.nameOfVendor || ""}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} marginBottom={2}>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: 14 }}>Vendor Address</Typography>
                <Typography variant="span">
                  {documentDetails?.addressOfVendor || ""}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: 14 }}>Vendor Email </Typography>
                <Typography>
                  {" "}
                  {documentDetails?.emailIdOfVendor || ""}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: 14 }}>
                  Vendor Business Description{" "}
                </Typography>
                <Typography variant="span">
                  {documentDetails?.descriptionOfBusinessOfVendor || ""}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} marginBottom={2}>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: 14 }}>
                  Service Scope Description
                </Typography>
                <Typography variant="span">
                  {documentDetails?.descriptionOfScopeOfService || ""}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: 14 }}>
                  Commercials Breakup{" "}
                </Typography>
                <Typography>
                  {" "}
                  {documentDetails?.breakupOfCommercials || ""}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: 14 }}>
                  Invoice Submission Payment time{" "}
                </Typography>
                <Typography variant="span">
                  {documentDetails?.timeForPaymentOfInvoiceSubmission || ""}
                </Typography>
              </Grid>
            </Grid>

            {documentDetails.typeOfVendor === "EXISTING" && (
              <Grid container spacing={2} marginBottom={2}>
                <Grid item xs={4}>
                  <Typography sx={{ fontSize: 14 }}>Pan Number</Typography>
                  <Typography variant="span">
                    {documentDetails?.panCard || ""}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ fontSize: 14 }}>Aadhar Number</Typography>
                  <Typography>{documentDetails?.aadharUpload || ""}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ fontSize: 14 }}>GST Number</Typography>
                  <Typography variant="span">
                    {documentDetails?.gstCertificate || ""}
                  </Typography>
                </Grid>
              </Grid>
            )}

            <Typography variant="h6">Uploaded Documents</Typography>
            <Stack direction="row" spacing={"20px"}>
              {documentDetails.typeOfVendor === "NEW" && (
                <>
                  {documentDetails?.panCard && (
                    <Link target="_blank" href={documentDetails?.panCard || ""}>
                      Pancard
                    </Link>
                  )}
                  {documentDetails?.gstCertificate && (
                    <Link
                      target="_blank"
                      href={documentDetails?.gstCertificate || ""}
                    >
                      GST Certificate
                    </Link>
                  )}

                  {documentDetails?.aadharUpload && (
                    <Link
                      target="_blank"
                      href={documentDetails?.aadharUpload || ""}
                    >
                      Aadhar Card
                    </Link>
                  )}
                </>
              )}
              <>
                {documentDetails?.originalAgreement && (
                  <Link
                    target="_blank"
                    href={documentDetails?.originalAgreement || ""}
                  >
                    Original Agreement
                  </Link>
                )}
                {documentDetails?.supportingDocument1 && (
                  <Link
                    target="_blank"
                    href={documentDetails?.supportingDocument1 || ""}
                  >
                    Supporting Document 1
                  </Link>
                )}
                {documentDetails?.supportingDocument2 && (
                  <Link
                    target="_blank"
                    href={documentDetails?.supportingDocument2 || ""}
                  >
                    Supporting Document 2
                  </Link>
                )}
              </>
              {Object.keys(uploadDocs || {})?.map((docKey) => {
                return (
                  <Link href={uploadDocs[docKey]} target="_blank">
                    {convertToCamelCaseFromUnderScore(docKey)}
                  </Link>
                );
              })}
            </Stack>
          </Grid>
          <Grid xs={5}>
            <ApprovalTimeLine
              documentDetails={documentDetails}
              onSuccess={loadData}
              docId={id}
            />
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};

export default DocumentDetails;
